import React, { useState } from 'react'
import styled from 'styled-components'
import { BigNumber } from '@ethersproject/bignumber'
import { formatCurrency } from '../../../model'
import { SingleItem } from './SingleItem'
import { getSlippageToleranceDisplay } from '../../../pages/swap/getSwapDisplays'
import { Parameter, Parameters } from './Parameters'

interface Props {
  description: string
  symbol0: string
  symbol1: string
  value0: string
  value1: string
  label0: string
  label1: string
  now: Date
  submittedAt: number
  slippageTolerance: string
  fees: string
  gasPrepay?: string
  ethRefund?: string
  moreDetails?: Record<string, string>
}

export function SingleOrderItem({
  description,
  symbol0,
  symbol1,
  value0,
  value1,
  label0,
  label1,
  now,
  submittedAt,
  slippageTolerance,
  fees,
  gasPrepay,
  ethRefund,
  moreDetails,
}: Props) {
  const [active, setActive] = useState(false)
  return (
    <Container onMouseEnter={() => setActive(true)} onMouseLeave={() => setActive(false)}>
      <SingleItem description={description} now={now} symbol0={symbol0} symbol1={symbol1} submittedAt={submittedAt} />
      <Parameters>
        {value0 && <Parameter text={label0} value={value0} />}
        {value1 && <Parameter text={label1} value={value1} />}
        {active && (
          <>
            {gasPrepay && (
              <Parameter
                text={ethRefund ? 'Execution Gas' : 'Execution Gas Prepay'}
                value={`${getExecutionGas(gasPrepay, ethRefund)} ETH`}
              />
            )}
            <Parameter text={'Slippage Tolerance'} value={getSlippageToleranceDisplay(parseInt(slippageTolerance))} />
            <Parameter text={'Fees'} value={fees} />
            {moreDetails &&
              Object.keys(moreDetails).map((key) => {
                return <Parameter key={key} text={key} value={moreDetails[key]} />
              })}
          </>
        )}
      </Parameters>
    </Container>
  )
}

function getExecutionGas(gasPrepay: string, ethRefund?: string) {
  return ethRefund
    ? formatCurrency(18, BigNumber.from(gasPrepay).sub(ethRefund))
    : formatCurrency(18, BigNumber.from(gasPrepay))
}

const Container = styled.div``
